import styled, { css } from 'styled-components'
import { Tab, Tabs } from '@material-ui/core'

export const Wrapper = styled.div`
  width: 100%;
`

type StyledTabProps = {
  primary?: string
}

export const StyledTabs = styled(Tabs)<StyledTabProps>`
  width: 800px;
  height: 40px !important;

  .MuiTabs-flexContainer {
    display: flex !important;
    gap: 20px !important;
  }

  .MuiTabs-indicator {
    background-color: #fff;
    display: none !important;
    border-radius: 0px !important;
  }

  ${({ primary }) =>
    primary &&
    css`
      & .MuiTabs-indicator {
        background-color: ${({ theme }) => theme.colors.primary};
      }
    `}
`

export const StyledTab = styled(Tab)<StyledTabProps>`
  span {
    text-transform: capitalize;
    color: ${({ theme }) => theme.ds.colors.neutral700};
    font-weight: 600;
    font-size: ${({ theme }) => theme.font.sizes.medium};
  }

  &.MuiTab-root {
    background-color: ${({ theme }) => theme.ds.colors.white};
    /* border-radius: 6px 6px 0 0; */
  }

  &.Mui-selected {
    &.MuiTab-root {
      background-color: ${({ theme }) => theme.colors.primary};
      /* border-radius: 6px 6px 0 0; */
    }

    & .MuiTab-wrapper {
      font-weight: 600;
      color: ${({ primary, theme }) =>
        primary ? theme.colors.primary : theme.colors.white};
    }
  }

  ${({ primary }) =>
    primary &&
    css`
      &.MuiButtonBase-root {
        background: #fff;

        & + &.MuiButtonBase-root {
          margin-left: 4px;
        }
      }
    `}
`

export const ActiveTabPanel = styled.div``
